export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const PAGING_INFO = 'PAGING_INFO';
export const POPUP_INIT = 'POPUP_INIT';
export const SELECTED_ROW = 'SELECTED_ROW';
export const POPUP_SEARCH_PARAM = 'POPUP_SEARCH_PARAM';
export const POPUP_PAGING_INFO = 'POPUP_PAGING_INFO';
export const ATTENTION_LIST = 'ATTENTION_LIST';
export const ERROR_LIST = 'ERROR_LIST';

export default {
	STATE_INIT,
	DEFAULT_ASSIGN,
	SEARCH_PARAM,
	PAGING_INFO,
	SELECTED_ROW,
	POPUP_INIT,
	POPUP_SEARCH_PARAM,
	POPUP_PAGING_INFO,
	ERROR_LIST,
	ATTENTION_LIST
};
